import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import { Box, Button } from '@material-ui/core';
import {
  useMediaQuery
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import SubItem from './SubItem'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "react-router-dom";
import { useTranslate, Title, useDataProvider, Loading, usePermissions } from 'react-admin';
import CreateClusterDialog from '../dashboard/CreateClusterDialog'
import icSearch from '../assets/icons/grayscale-3-search.png'
import ResultSearchRoom from '../CustomizedUIs/ResultSearchRoom';
import CustomSwitch from '../CustomizedUIs/GreenSwitch';
import ArrowRightButton from '../CustomizedUIs/ArrowRightButton';
import GoBackButton from '../CustomizedUIs/GoBackButton'
import colors from '../CustomizedUIs/Colors';


const useStyles = makeStyles((theme) => ({
  searchPaper: {
    padding: "4px 2px",
    display: "flex",
    alignItems: "center",
    margin: "auto 0",
    boxShadow: "none",
    width: 236,
  },
  input: {
    marginLeft: "9.7px",
    flex: 1,
    width: 236,
    fontFamily: "UniviaPro-Book",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#88898c",
    "&::placeholder": {
      color: "#88898c",
      opacity: 1,
    },
  },
  borderGroup: {
    backgroundColor: " #ffffff",
  },
  textGroup: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#4f5064",
  },
  TextCluster: {
    fontFamily: "UniviaPro-Bold",
    fontSize: "9px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.22,
    letterSpacing: "0.36px",
    color: "#6cb5b8",
  },
  borderCluster: {
    borderRadius: "10px",
    border: "solid 1px #e0f0f2",
    backgroundColor: "#fafefe",
    padding: "11px",
  },
  borderArrow: {
    borderRadius: "10px",
    backgroundColor: " #e5f1f8",
  },
  headerBack: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "15px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: theme.palette.primary.main,
  },
  borderBack: {
    borderRadius: " 10px",
    backgroundColor: "#237fc2",
    "&:hover": {
      backgroundColor: "#65a9db",
    },
  },
  TitleName: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "18px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: "#4f5064",
  },
  boderSearch: {
    borderRadius: "10px",
    border: "solid 1px #e0f0f2",
    backgroundColor: "#ffffff",
  },
  TitleAddCluster: {
    fontFamily: "UniviaPro-Bold",
    fontSize: "10px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.4px",
    color: "#4f5064",
  },
  btnSearchRoom: {
    fontFamily: "UniviaPro-Bold",
    fontSize: "9px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.22,
    letterSpacing: "0.36px",
    color: theme.palette.primary.main,
    padding: 4,
  },
}));

const ClusterItem = ({ data }) => {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
  const translate = useTranslate();
  const classes = useStyles();
  const theme = useSelector((state) =>
    state.theme === 'dark' ? darkTheme : lightTheme
  );

  return (
    <Box className={classes.borderGroup}>
      <Box display='flex' width='100%'>
        <Box width='100%' ml='6px'>
          <ListItem
            button
            style={{ paddingTop: '1em', paddingBottom: '1em' }}
            component={Link}
            to={{
              pathname: "/Cluster/" + data.id,
            }}>
            <ListItemText primary={<Typography className={classes.textGroup}>{data.name}</Typography>} />
            <Box borderRadius='10px'
              width='79px'
              textAlign='center'
              className={classes.borderCluster}
              py={1} mr={1} >
              <Typography className={classes.TextCluster} >
                {(data.roomCount + " " + translate(data.roomCount <= 1 ? `resources.group.room` : `resources.group.rooms`)).toUpperCase()}
              </Typography>
            </Box>
            <Box borderRadius='10px'
              width='79px'
              textAlign='center'
              className={classes.borderCluster}
              px={isDesktop ? 2 : "1px"}
              py={1} mr={isDesktop ? 10 : 1}
            >
              <Typography className={classes.TextCluster} >
                {((data.devices === 0 || data.devices === 1) ? (data.devices + " " + translate(`resources.group.tv`).toUpperCase()) :
                  (data.devices + " " + translate(`resources.group.tvs`)).toUpperCase())}
              </Typography>
            </Box>
            <ArrowRightButton color={theme.squareButon.content} />

          </ListItem>
        </Box>
      </Box>

    </Box>
  )

}


const GroupItem = ({ data, arrayData }) => {

  return (

    <Box width='100%' my={2}>
      <SubItem
        name={data.name}
        countCluster={data.clusters}
      >
        <List component="div" disablePadding>
          {
            arrayData.cluster.filter(value => value.group === data.name && value.entity === data.entity).map((row, index) => (
              <ClusterItem key={index} data={row} />
            ))
          }

        </List>

      </SubItem>
    </Box>
  )

}

const Groups = (props) => {
  const translate = useTranslate();
  const classes = useStyles();
  const { permissions, loaded } = usePermissions();
  const [filter, setFilter] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCreate, setOpenCreate] = useState(false);
  const dataProvider = useDataProvider();
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));

  const [error, setError] = useState();
  const [searchRoom, setSearchRoom] = useState(false);
  const theme = useSelector((state) =>
    state.theme === 'dark' ? darkTheme : lightTheme
  );

  // useEffect(() => {
  //     console.log(props.match.params.id)
  //     dataProvider('GET_LIST', "nodes", {
  //         filter: {
  //             nodeLevel: 2,
  //             parentId: parseInt(props.match.params.id)
  //         },
  //         pagination: {},
  //         sort: { field: 'name', order: 'ASC' },

  //     })
  //         .then(({ data }) => {
  //             setData(data);
  //             setLoading(false);
  //         })
  //         .catch(error => {
  //             setError(error);
  //             setLoading(false);
  //         })
  // }, []);

  useEffect(() => {
    dataProvider('GET_LIST', "ClusterAssign", {
      filter: {
      },
      pagination: {},
      sort: { field: 'name', order: 'ASC' },

    })
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      })
  }, [openCreate]);

  if (loading) return <Loading />;
  if (error) return null;
  if (!data) return null;
  if (!loaded) return null

  const searchOnChange = (e) => {
    setFilter(e.target.value)
  }

  const clickAddCluster = () => {
    setOpenCreate(true)
  }

  const handelCloseDialog = () => {
    setOpenCreate(false)
  }

  const handleChangeToSearchRoom = () => {
    setSearchRoom(prev => !prev)
  }
  return (
    <Box width="100%">
      <Title title={decodeURIComponent(props.match.params.name)} />
      <Box width={!isDesktop ? "95%" : "80%"} m="auto">
        <Box my={2}>
          <Box
            my={5}
            width={300}
            display="flex"
            component={Link}
            to="/"
            style={{ textDecoration: "none" }}
          >
            <Box display="flex" mr={2}>
              <GoBackButton color={theme.squareButon.content} />
            </Box>
            <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>
              {translate(`resources.group.back`)}
            </Typography>
          </Box>
          <Box display="flex">
            <Typography
              className={classes.TitleName}
              style={{ margin: "auto 0" }}
            >
              {decodeURIComponent(props.match.params.name)}
            </Typography>

            <Box
              flexGrow={1}
              my="auto"
              display="flex"
              justifyContent="flex-end"
            >
              <Box
                my="auto"
                marginRight="40px"
                display="flex"
                alignItems="center"
              >
                {searchRoom ? (
                  <ResultSearchRoom
                    textHolder={translate(`pos.devices.search_rooms`)}
                  />
                ) : (
                    <Box className={classes.boderSearch} mr={2}>
                      <Paper component="form" className={classes.searchPaper}>
                        <img
                          src={icSearch}
                          width={17.6}
                          height={17.6}
                          style={{ marginLeft: "10.7px" }}
                        ></img>
                        <InputBase
                          InputLabelProps={{
                            className: classes.input,
                          }}
                          placeholder={translate(`resources.group.search`)}
                          inputProps={{
                            "aria-label": "search",
                            className: classes.input,
                          }}
                          onChange={searchOnChange}
                        />
                      </Paper>
                    </Box>
                  )}

                <Box
                  alignItems="center"
                  display="flex"
                  style={{
                    padding: "6px 8px",
                    borderRadius: "0",
                    backgroundColor: "#ffffff",
                    borderRadius: "10px",
                    border: "1px solid #e0f0f2",
                  }}
                >
                  <Typography className={classes.btnSearchRoom}>
                    {translate(`pos.devices.search_rooms`).toUpperCase()}
                  </Typography>

                  <CustomSwitch
                    size="small"
                    onChange={handleChangeToSearchRoom}
                  />

                </Box>
              </Box>
              {permissions.functionAction.find(
                (value) => value.function === "CRUD Cluster" && value.isCreate
              ) && (
                  <Box
                    ml={3}
                    my="auto"
                    component={Button}
                    onClick={clickAddCluster}
                    style={{ textTransform: "none" }}
                  >
                    <Typography className={classes.TitleAddCluster}>
                      {translate(`pos.dashboard.addCluster`)}
                    </Typography>
                  </Box>
                )}
            </Box>
          </Box>
        </Box>
        <Box>
          {data.countResult.groups
            .filter(
              (value) =>
                value.entity === decodeURIComponent(props.match.params.name) &&
                value.name
                  .replace(/ /g, "")
                  .toUpperCase()
                  .indexOf(filter.replace(/ /g, "").toUpperCase()) > -1
            )
            .map((row, index) => (
              <GroupItem key={index} data={row} arrayData={data} />
            ))}
        </Box>
      </Box>
      <CreateClusterDialog
        {...props}
        open={openCreate}
        handleClose={handelCloseDialog}
        dataRecever={data}
        autoPickEnity={decodeURIComponent(props.match.params.name)}
      />
    </Box>
  );

}
export default Groups

